import { useState, useMemo, useRef } from "react"
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Popper,
  Paper,
  ClickAwayListener,
  TextField,
  InputAdornment,
} from "@mui/material"
import { ExpandMore, ExpandLess, Search } from "@mui/icons-material"

function ClientBalanceCard({ stats }) {
  const [open, setOpen] = useState(false)
  const [search, setSearch] = useState("")
  const anchorRef = useRef(null)

  const clients = stats?.clients || []
  const totalClients = stats?.count || clients.length

  // Filter clients by name
  const filteredClients = useMemo(() => {
    return clients.filter((client) =>
      client.name?.toLowerCase().includes(search.toLowerCase())
    )
  }, [clients, search])

  return (
    <>
      <Card sx={{ height: "100%" }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box>
              <Typography variant="overline" color="textSecondary">
                Current Client Balance
              </Typography>

              <Typography variant="h4" fontWeight="bold">
                ₹{(stats?.totalBalanceCarried || 0).toLocaleString()}
              </Typography>

              <Typography variant="body2" color="textSecondary">
                {totalClients} clients with balance
              </Typography>
            </Box>

            <IconButton
              ref={anchorRef}
              onClick={() => setOpen((prev) => !prev)}
            >
              {open ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Box>
        </CardContent>
      </Card>

      {/* Floating dropdown */}
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Paper
            sx={{
              mt: 1,
              width: 300,
              maxHeight: 350,
              display: "flex",
              flexDirection: "column",
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            {/* Search Bar */}
            <Box sx={{ p: 1.5 }}>
              <TextField
                size="small"
                fullWidth
                placeholder="Search client..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            {/* List */}
            <Box
              sx={{
                overflowY: "auto",
                maxHeight: 280,

                "&::-webkit-scrollbar": { width: 6 },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#ccc",
                  borderRadius: 3,
                },
              }}
            >
              <List dense>
                {filteredClients.length > 0 ? (
                  filteredClients.map((client) => (
                    <ListItem key={client._id} divider>
                      <ListItemText
                        primary={client.name}
                        secondary={`₹${client.balance.toLocaleString()}`}
                      />
                    </ListItem>
                  ))
                ) : (
                  <Typography
                    variant="body2"
                    sx={{ p: 2, textAlign: "center", color: "text.secondary" }}
                  >
                    No clients found
                  </Typography>
                )}
              </List>
            </Box>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  )
}

export default ClientBalanceCard